import React from 'react';
import { IProps as IBlockProps } from './SecondaryNavigation.interface';
import { SecondaryNavigation } from './SecondaryNavigation.component';
import TranslationComponent from '@/utils/TranslationComponent/TranslationComponent';

interface IBlockInputProps {
    backLink?: {
        text: string;
        href: string;
        ariaLabel?: string;
    } | null;
    items: Array<{
        menu: {
            text: string;
            href: string;
            ariaLabel?: string;
            onToggle?: () => void;
        };
        isExpanded: boolean;
        isSelected: boolean;
        subMenu?: any[];
    }>;
    [key: string]: any;
}

const mapInputToProps = (input: IBlockInputProps): IBlockProps => {
    const { ...rest } = input;
    return {
        ...rest,
    }
};

const BlockTranslation: React.FC<IBlockInputProps> = (props) => (
    <TranslationComponent
        inputProps={props}
        TargetComponent={SecondaryNavigation}
        mapProps={mapInputToProps}
    />
);

export default BlockTranslation;
